<!-- Header -->
<h3 mat-dialog-title
	style="text-align: center; color: #b71c1c;">
	WARNING
</h3>

<!-- Body -->
<mat-dialog-content style="text-align: center; width: 250px;">
	This will delete the query
	<br>
	{{query.QueryName}}
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

	<!-- Right Buttons -->
	<div class="footerRight">
		<tyl-button image="save.png"
			label="Delete"
			(clickEvent)="delete()"></tyl-button>
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>